"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listVerifications = exports.updateVerification = exports.getVerification = exports.changeVerificationStatus = exports.getVerificationStatus = exports.saveVerification = exports.findVerification = exports.client = void 0;
var axios_1 = __importDefault(require("@vtblife/axios"));
var querystring_1 = require("querystring");
exports.client = axios_1.default.create();
exports.client.defaults.paramsSerializer = querystring_1.encode;
exports.client.defaults.baseURL = "/api/client-verification";
function findVerification(_a) {
  var params = _a.params,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "get",
            url: "/v1/verification/m2pro",
            data: {},
            params: params,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.findVerification = findVerification;
function saveVerification(_a) {
  var data = _a.data,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "post",
            url: "/v1/verification/m2pro",
            data: data,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.saveVerification = saveVerification;
function getVerificationStatus(_a) {
  var params = _a.params,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "get",
            url: "/v1/verification/m2pro/status",
            data: {},
            params: params,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.getVerificationStatus = getVerificationStatus;
function changeVerificationStatus(_a) {
  var data = _a.data,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "put",
            url: "/v1/verification/m2pro/status",
            data: data,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.changeVerificationStatus = changeVerificationStatus;
function getVerification(_a) {
  var urlParams = _a.urlParams,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "get",
            url: "/v1/verification/m2pro/" + urlParams.id,
            data: {},
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.getVerification = getVerification;
function updateVerification(_a) {
  var data = _a.data,
    urlParams = _a.urlParams,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "put",
            url: "/v1/verification/m2pro/" + urlParams.verificationId,
            data: data,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.updateVerification = updateVerification;
function listVerifications(_a) {
  var data = _a.data,
    headers = _a.headers,
    cancelToken = _a.cancelToken;
  return __awaiter(this, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, exports.client({
            method: "post",
            url: "/v1/verification/m2pro:list",
            data: data,
            headers: headers,
            cancelToken: cancelToken
          })];
        case 1:
          result = _b.sent();
          return [2 /*return*/, result.data];
      }
    });
  });
}
exports.listVerifications = listVerifications;